var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ml-1",attrs:{"icon":_vm.isIcon,"rounded":!_vm.isIcon,"small":"","outlined":"","elevation":"2","disabled":_vm.disabled,"color":!_vm.disabled && hover ? 'primary' : _vm.color},on:{"click":_vm.onClick}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":_vm.isIcon}},[_vm._v("mdi-"+_vm._s(_vm.icon))])],1)]}}],null,true)})]}}])},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }